export enum COOKIE_KEYS {
  IS_LOGGED_IN = 'isLoggedIn',
  COMPOSIO_EMAIL = 'composio_email',
  COMPOSIO_ANALYTICS_ID = 'composio_analytics_id',
}
